import React, { useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { useCurrencyStore } from "../../store/currencyStore";

const CurrencyPerformanceChart: React.FC = () => {
  const { currencies, fetchCurrencies } = useCurrencyStore();

  useEffect(() => {
    if (currencies.length === 0) {
      fetchCurrencies();
    }
  }, [currencies.length, fetchCurrencies]);

  // Map store data
  const series = currencies.map((c) => c.rate);
  const labels = currencies.map((c) => c.currency);

  const options: ApexOptions = {
    chart: {
      type: "pie",
    },
    labels,
    colors: ["#4188C1", "#4DB0AA", "#5664B6", "#E8A317", "#E95420"], // extra colors if more currencies
    stroke: {
      show: false,
    },
    legend: {
      position: "bottom",
      labels: {
        colors: "#fff",
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 250,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  };

  return (
    <div className="bg-card p-6 rounded-2xl shadow-lg w-full max-w-md mx-auto">
      <h2 className="text-md font-semibold text-white mb-4 text-left">
        Portfolio Allocation
      </h2>
      <ReactApexChart
        options={options}
        series={series}
        type="pie"
        height={370}
      />
    </div>
  );
};

export default CurrencyPerformanceChart;
